const initSubscription = () => {
  const subscriptionForm = document.querySelector('[data-subscription-form]');
  const successMessage = document.querySelector('[data-subscription-success-message]');
  const errorMessage = document.querySelector('[data-subscription-error-message]');
  const failMessage = document.querySelector('[data-subscription-fail-message]');

  if (!subscriptionForm) return;

  subscriptionForm.addEventListener('submit', (e) => {
    e.preventDefault();

    const action = subscriptionForm.action;
    const formData = new FormData(subscriptionForm);

    fetch(action, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          subscriptionForm.querySelector('input').value = '';
          errorMessage.classList.add('hidden');
          failMessage.classList.add('hidden');
          successMessage.classList.remove('hidden');
          response.json();
        } else {
          console.warn('HTTP error: ' + response.status);
          successMessage.classList.add('hidden');
          failMessage.classList.add('hidden');
          errorMessage.classList.remove('hidden');
        }
      })
      .catch((error) => {
        console.warn('error: ' + error);
        successMessage.classList.add('hidden');
        errorMessage.classList.add('hidden');
        failMessage.classList.remove('hidden');
        throw new Error(error);
      });
  });
};

export default initSubscription;
